import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoader, setSnackbar } from 'redux/index';
import * as services from 'services';
import { usePasswordConfirm } from 'helpers';
import { DeleteButton } from 'components';

export default function DeleteHouseButton({ houseId, houseSort, disabled }) {
	const onPasswordConfirm = usePasswordConfirm();
	const dispatch = useDispatch();
	const history = useHistory();

	const onDeleteHouse = async (pass) => {
		dispatch(setLoader(true));
		await services
			.deleteHouse(houseId, pass)
			.then(() => {
				services.setFetchedHouseList(houseSort).then(() => {
					dispatch(
						setSnackbar({
							variant: 'success',
							message: 'Home deleted successfully',
						}),
					);
					history.push(`/homes/`);
				});
			})
			.catch((error) => {
				dispatch(
					setSnackbar({
						variant: 'error',
						message: error.message,
					}),
				);
			})
			.finally(() => dispatch(setLoader(false)));
	};

	return (
		<DeleteButton
			onClick={() =>
				onPasswordConfirm(
					(pass) => onDeleteHouse(pass),
					'This is a permanent option and cannot be undone. Please confirm your password.',
				)
			}
			disabled={disabled}>
			Delete
		</DeleteButton>
	);
}
